import { render, staticRenderFns } from "./shot.vue?vue&type=template&id=96e81810&scoped=true&"
import script from "./shot.vue?vue&type=script&lang=js&"
export * from "./shot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e81810",
  null
  
)

export default component.exports